import { all, call, put, spawn, takeLatest } from 'redux-saga/effects';
import profileActions from '../general/actions';
import { companyTechTagsActions } from './actions';
import { mutateCompanyTechTags } from './graphql';
import { COMPANY_TECH_TAGS_MUTATE_START } from './types';

function* companyTechTagsMutationGenerator(action: any): any {
  const {
    data: { companyProfileUpdateTechStack },
  } = yield call(mutateCompanyTechTags, action.payload);

  yield put(
    companyTechTagsActions.companyTechTagsUpdate(
      companyProfileUpdateTechStack.map((companyTechTag: any) => companyTechTag.name)
    )
  );
  yield put(profileActions.createProfileSnapshot());
}

function* companyTechTagsMutate() {
  yield takeLatest(COMPANY_TECH_TAGS_MUTATE_START, companyTechTagsMutationGenerator);
}

export default function* rootSaga() {
  yield all([spawn(companyTechTagsMutate)]);
}
